app.controller("EditLecturerController", ["$scope", "$uibModalInstance", "Lecturer", "StaticData", "lecturer",
    function ($scope, $uibModalInstance, Lecturer, StaticData, lecturer) {
        $scope.faculty = lecturer.info ? lecturer.info.faculty : null;
        $scope.rank = lecturer.info ? lecturer.info.rank : null;

        $scope.editLecturer = function () {
            lecturer.info = lecturer.info || {};
            lecturer.info.faculty = $scope.faculty;
            lecturer.info.rank = $scope.rank;
            Lecturer.edit(lecturer).then(function () {
                $uibModalInstance.close();
            })
        };

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("lecturer_ranks").then(function (ranks) {
            $scope.ranks = [{name: "თანამდებობა"}].concat(ranks);
            $scope.ranksMap = _.keyBy($scope.ranks, '_id');
        });

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);